module.exports = __webpack_public_path__ + "media/images/country_flags/kp-a580f99eb64f165ebf0c2e7c138c2a3c.png";